// extracted by mini-css-extract-plugin
export default {"search":"search-box_search__ze-FJ"};